module.exports = __webpack_public_path__ + "static/dance_1024-4833119f54fcefe10443104bae7abfba.jpg";